import { render, staticRenderFns } from "./FirstPartyList.vue?vue&type=template&id=b2ab2492"
import script from "./FirstPartyList.vue?vue&type=script&lang=js"
export * from "./FirstPartyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports